import { InjectionToken } from '@angular/core';
import { MuiDatepickerV2Format } from '../forms/datepicker-v2/supported-formats';


export interface MuiConfiguration {
  /**
   * The default date format to use for date pickers.
   */
  dateFormat: MuiDatepickerV2Format;
}

/**
 * Provides a way to configure the Miele UI library, e.g. for localization and formatting.
 */
export class MuiDefaultConfiguration implements MuiConfiguration {
  dateFormat: MuiDatepickerV2Format = 'YYYY-MM-DD';
}

export const MUI_CONFIGURATION = new InjectionToken<MuiConfiguration>('MUI_CONFIGURATION', {
  providedIn: 'root',
  factory: (): MuiConfiguration => new MuiDefaultConfiguration()
});
